export default __webpack_public_path__ + "static/small1@2x-911f03325e3bdfece2506396986c6b2e.jpg";